module.exports = __webpack_public_path__ + "static/media/outfit-burberry.9854ad9d.jpg";